import { render, staticRenderFns } from "./Permission.vue?vue&type=template&id=12d3a63d&scoped=true&"
import script from "./Permission.vue?vue&type=script&lang=js&"
export * from "./Permission.vue?vue&type=script&lang=js&"
import style0 from "./Permission.vue?vue&type=style&index=0&id=12d3a63d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d3a63d",
  null
  
)

export default component.exports